import enGeneralError from '@pages/general-error/locales/en.json'
import esGeneralError from '@pages/general-error/locales/es.json'
import ptGeneralError from '@pages/general-error/locales/pt.json'
import enMaintenance from '@pages/maintenance/locales/en.json'
import esMaintenance from '@pages/maintenance/locales/es.json'
import ptMaintenance from '@pages/maintenance/locales/pt.json'
import enNotfound from '@pages/not-found/locales/en.json'
import esNotfound from '@pages/not-found/locales/es.json'
import ptNotfound from '@pages/not-found/locales/pt.json'
import i18n from 'i18next'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'
import enGlobal from './assets/locales/en.json'
import esGlobal from './assets/locales/es.json'
import ptGlobal from './assets/locales/pt.json'

export const defaultNS = 'outside'
export const resources = {
  en: {
    outside: enGlobal,
    notFound: enNotfound,
    maintenance: enMaintenance,
    generalError: enGeneralError,
  },
  pt: {
    outside: ptGlobal,
    notFound: ptNotfound,
    maintenance: ptMaintenance,
    generalError: ptGeneralError,
  },
  es: {
    outside: esGlobal,
    notFound: esNotfound,
    maintenance: esMaintenance,
    generalError: esGeneralError,
  },
} as const

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    defaultNS,
    ns: ['outside', 'notFound', 'maintenance', 'generalError'],
    load: 'all',
    supportedLngs: ['en', 'es', 'pt'],
    fallbackLng: 'en',
    lng: navigator.language?.split('-')[0] || 'en',
    debug: false,
    cache: {
      enabled: false,
    },
    resources,
  })

export default i18n
